import { render, staticRenderFns } from "./DefaultProjectTask.vue?vue&type=template&id=91083ad8&"
import script from "./DefaultProjectTask.vue?vue&type=script&lang=js&"
export * from "./DefaultProjectTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports